import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { Outlet } from '@tanstack/react-router';
import useUtmTags from './useUtmTags';
import useInviteCode from './useInviteCode';

export default function App() {
  useUtmTags();
  useInviteCode();

  return (
    <>
      {createPortal(<ToastContainer />, document.body)}
      <Outlet />
    </>
  );
}
